import _ from 'lodash/fp';

export const _addMetadata = (
  urlStr?: string | null,
  metadataFlat?: Record<string, string> | null
) => {
  if (!urlStr) return null;
  const url = new URL(urlStr);
  if (metadataFlat) {
    _.forEach((key) => {
      const value = metadataFlat[key];
      if (!_.isNil(value)) url.searchParams.set(key, value);
    }, _.keys(metadataFlat));
  }
  return url.toString();
};

export class OpenBookmarkRejectedError extends Error {}

export const METADATA_PREFIX = 'm';
